//src/components/common/PrivacyPolicy/CompanyTermsAndPolicy/TermsAndPolicyHeader.jsx
import React from 'react'

const TermsAndPolicyHeader = ({ activeTab, setActiveTab }) => {
  const buttons = [
    { key: 'privacy', label: 'Privacy Policy' },
    { key: 'terms', label: 'Terms and Conditions' },
    { key: 'return', label: 'Return and Cancellation Policy' }
  ]

  return (
    <div className='mt-3 bg-[#b1c2f433] flex items-center gap-6 sm:gap-10 lg:gap-16 py-1.5 px-4 sm:px-10 text-sm rounded-md font-bold flex-wrap'>
      {buttons.map((btn, index) => (
        <React.Fragment key={btn.key}>
          <button
            onClick={() => setActiveTab(btn.key)}
            className={
              activeTab === btn.key
                ? 'bg-[#2d3d6f9c] py-3 px-4 rounded-md text-white'
                : 'text-[#6c63ff]'
            }
          >
            {btn.label}
          </button>
          {index !== buttons.length - 1 && (
            <p className="text-[#6c63ff]">|</p>
          )}
        </React.Fragment>
      ))}
    </div>
  )
}

export default TermsAndPolicyHeader